import { getStoreBuilder, BareActionContext } from "vuex-typex";
import { ProductListState, RootState, PorterBudgetState } from "Store/types";
import { State } from "vuex-class";
import { FilterItem } from "Models/FacetFilter/FilterItem";
import { ProductListPage } from "Models/Products/ProductListPage";
import { Client, GetPorterProductListItemsViewModel, PorterItemViewModel, PorterItemsSize, PorterBudget, IPorterBudget, PorterViewModel, IPorter } from "Api/CoreApi";
import ApiProvider from "Api/ApiProvider";
import axios, { AxiosResponse } from 'axios';

const initialPorterBudgetState: PorterBudgetState = {
    isPorter: false,
    porterNo: null,
    porter: null,
    porterBudget: null
}

const p = getStoreBuilder<RootState>().module("porterBudget", initialPorterBudgetState);
var loadPromise: Promise<any>;


function convertToPorter(payload: PorterViewModel): IPorter {
    return PorterViewModel.fromJS({
        customerNo: payload.customerNumber,
        contactNo: payload.contactNo,
        firstName: payload.firstName,
        lastName: payload.lastName,
        street: payload.street,
        city: payload.city,
        phone: payload.phone,
        zip: payload.zip,
        hasBudget: payload.hasBudget,
        showBudgetPoints: payload.showBudgetPoints,
        showBudgetPrice: payload.showBudgetPrice,
        functionCode: payload.functionCode,
        email: payload.email,
        nonDismissable: payload.nonDismissable,
        genericFields: payload.genericFields,
        id: payload.id
    });
}


// Mutations
function porterBudgetUpdated(state: PorterBudgetState, payload: IPorterBudget) {
    state.porterBudget = payload;
}

function porterIdUpdated(state: PorterBudgetState, payload: string) {
    state.porterNo = payload;
}

function porterUpdated(state: PorterBudgetState, payload: IPorter) {
    state.porter = payload;
}

function isPorterUpdated(state: PorterBudgetState, payload: boolean) {
    state.isPorter = payload;
}
//Getters

//Actions
async function fetchPorter(context: BareActionContext<PorterBudgetState, RootState>): Promise<IPorter> {
    if (loadPromise) return loadPromise;

    return loadPromise = new Promise(async (resolve, reject) => {
        const client = ApiProvider.getApiClient();
        client.getPorterByNo(porterBudget.state.porterNo)
            .then(async res => {
                if (res.porter) {
                    porterBudget.commitPorterUpdated(convertToPorter(res.porter));
                    resolve(res.porter);
                    loadPromise = null;
                } else {
                    reject("Could not get the porter from the server.");
                    loadPromise = null;
                }
            })
            .catch(e => {
                reject("Could not get the porter from the server.");
                loadPromise = null;
            });
    });
}

async function fetchPorterBudget(context: BareActionContext<PorterBudgetState, RootState>): Promise<IPorterBudget> {
    if (loadPromise) return loadPromise;

    return loadPromise = new Promise(async (resolve, reject) => {
        if (!porterBudget.state.porter) {
            await porterBudget.dispatchFetchPorter();
        }

        const client = ApiProvider.getApiClient();
        client.getPorterBudget(porterBudget.state.porter.contactNo)
            .then(async res => {
                if (res.budgets[0]) {
                    var budget = res.budgets[0];
                    var completeBudget = {
                        budgetAmountTotal: budget.budgetAmountTotal,
                        budgetAmountRemaining: budget.budgetAmountRemaining,
                        budgetAmountUsed: budget.budgetAmountUsed,
                        porterNo: budget.porterNo,
                        dateRenewed: budget.dateRenewed,
                        typeEuros: budget.typeEuros,
                        typePoints: budget.typePoints,
                    } as IPorterBudget;

                    const url = window.location.href;
                    const regex = /^(.*\/\/[^\/]+\/)([^\/]+)/;
                    const match = url.match(regex);
                    if (match) {
                        const subDomain = match[2]; // This will give you the subdomain (e.g. "b2b-en")
                        const budgetResponse = await axios.get(`/${subDomain}/dwapi/asyncbudgetinfo`);

                        var totalPriceInCart = budgetResponse.data.BudgetPrice;
                        var totalPointsInCart = budgetResponse.data.BudgetPoints;

                        if (completeBudget.typePoints) {
                            completeBudget.budgetAmountRemaining = completeBudget.budgetAmountRemaining - totalPointsInCart;
                            completeBudget.budgetAmountUsed = completeBudget.budgetAmountUsed + totalPointsInCart;
                        } else {
                            completeBudget.budgetAmountRemaining = completeBudget.budgetAmountRemaining - totalPriceInCart;
                            completeBudget.budgetAmountRemaining = Number(completeBudget.budgetAmountRemaining.toFixed(2));
                            completeBudget.budgetAmountUsed = completeBudget.budgetAmountUsed + totalPriceInCart;
                            completeBudget.budgetAmountUsed = Number(completeBudget.budgetAmountUsed.toFixed(2));
                        }
                        porterBudget.commitPorterBudgetUpdated(completeBudget);
                    } else {
                        console.log("Invalid URL format");
                    }
                }
                resolve(completeBudget);
                loadPromise = null;
            })
            .catch(e => {
                reject(e);
                loadPromise = null;
            });
    });
}

//State
const stateGetter = p.state();

const porterBudget = {
    //State
    get state() { return stateGetter() },

    //Getters
    // - nothing -

    //Mutations
    commitPorterIdUpdated: p.commit(porterIdUpdated),
    commitIsPorterUpdated: p.commit(isPorterUpdated),
    commitPorterBudgetUpdated: p.commit(porterBudgetUpdated),
    commitPorterUpdated: p.commit(porterUpdated),

    //Actions
    dispatchFetchPorterBudget: p.dispatch(fetchPorterBudget),
    dispatchFetchPorter: p.dispatch(fetchPorter),
}
export default porterBudget;